import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiOrders = () => {
 const { auth } = contextApp();

 const OrderApi = axios.create({
  baseURL: urls.order(),
  headers: { 'x-access-token': auth?.token }
 });

 const getOrders = async (params = {}) => (await OrderApi.get('/', { params })).data;

 const createOrder = async project => (await OrderApi.post('/', project)).data;

 return { getOrders, createOrder };
};

import { STOP_TYPES } from './Exchanges';

export const getOrders = async (symbol, page, token, size) => {
 const url = urls.orders({ symbol, page, size });
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data; // { count, rows }
};

export const cancelOrder = async (symbol, orderId, token) => {
 const url = urls.orders({ symbol, orderId });
 const headers = { 'x-access-token': token };
 const settings = await axios.delete(url, { headers });
 return settings.data; // { count, rows }
};

export const syncOrder = async (beholderOrderId, token, data = []) => {
 const url = urls.orders({ sync: true, beholderOrderId });
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, data, { headers });
 return settings.data; // { count, rows }
};
/* **************************placeOrder************************ */
export const placeOrder = async (order, token) => {
 const postOrder = {
  symbol: order.symbol.toUpperCase(),
  quantity: order.quantity,
  side: order.side.toUpperCase(),
  type: order.type.toUpperCase()
 }; /* Este código es una función de JavaScript que se utiliza para colocar una orden en algún tipo de mercado o plataforma de trading. La función es marcada como "async", lo que significa que se ejecutará de manera asíncrona y puede ser detenida en cualquier momento sin bloquear el resto del código.

La función recibe dos argumentos: "order" y "token". "Order" es un objeto que contiene información sobre la orden que se desea colocar, mientras que "token" es una cadena de texto que se utiliza para autenticar la solicitud.

Dentro de la función, se crea un nuevo objeto "postOrder" que contiene información sobre la orden que se desea colocar. Esta información incluye el símbolo de la moneda o acción, la cantidad de unidades que se desean comprar o vender, el lado de la orden (compra o venta) y el tipo de orden (por ejemplo, limitada o stop).

Antes de crear el objeto "postOrder", la función convierte todas las propiedades del objeto "order" a mayúsculas utilizando el método ".toUpperCase()". Esto se hace para asegurarse de que la información se envíe en un formato uniforme y evitar posibles errores.

Una vez que se ha creado el objeto "postOrder", se puede utilizar para enviar la solicitud de orden a la plataforma de trading. Sin embargo, el código no incluye la implementación de la llamada a la API o la lógica para manejar la respuesta. */

 if (order.type !== 'MARKET') postOrder.price = order.price;
 else if (order.type === 'ICEBERG') postOrder.options = { icebergQty: order.icebergQty };
 else if (STOP_TYPES.indexOf(order.type) >= 0) postOrder.options = { stopPrice: order.stopPrice, type: order.type };
 /* Este código es un bloque de control de flujo que asigna diferentes valores a un objeto "postOrder" en función del tipo de orden especificado en un objeto "order".
Primero, se verifica si el tipo de orden en el objeto "order" es diferente de "MARKET". Si es así, el precio se asigna al objeto "postOrder".
Si el tipo de orden es igual a "ICEBERG", se agrega una opción "icebergQty" al objeto "postOrder".
Si el tipo de orden se encuentra en el arreglo "STOP_TYPES", se agrega una opción "stopPrice" y "type" al objeto "postOrder".

En resumen, el código determina diferentes acciones para diferentes tipos de órdenes y las asigna al objeto "postOrder". */

 const url = urls.orders();
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, postOrder, { headers });
 return settings.data; // { count, rows }
};

export default { getOrders, cancelOrder, placeOrder, syncOrder };

/*  *******************DEFINICION GENERAL*****************

Este código es un módulo de Node.js que proporciona diferentes funciones relacionadas con las órdenes de una bolsa de valores.

La primera función es getOrders, que permite obtener las órdenes de un símbolo específico. Esta función toma tres argumentos: symbol, page y token, y usa la biblioteca Axios para hacer una solicitud HTTP GET a una URL específica, proporcionando un token de acceso en el encabezado de la solicitud. La URL se construye utilizando una función de la biblioteca de configuración (urls.orders).

La segunda función es cancelOrder, que permite cancelar una orden específica. Esta función toma tres argumentos: symbol, orderId y token, y usa la biblioteca Axios para hacer una solicitud HTTP DELETE a una URL específica, proporcionando un token de acceso en el encabezado de la solicitud. La URL se construye utilizando una función de la biblioteca de configuración (urls.orders).

La tercera función es syncOrder, que permite sincronizar una orden específica. Esta función toma tres argumentos: beholderOrderId, token y data (que es una matriz opcional), y usa la biblioteca Axios para hacer una solicitud HTTP POST a una URL específica, proporcionando un token de acceso en el encabezado de la solicitud. La URL se construye utilizando una función de la biblioteca de configuración (urls.orders).

La cuarta función es placeOrder, que permite colocar una orden en la bolsa de valores. Esta función toma un argumento: order y token, y usa la biblioteca Axios para hacer una solicitud HTTP POST a una URL específica, proporcionando un token de acceso en el encabezado de la solicitud. La URL se construye utilizando una función de la biblioteca de configuración (urls.orders). Antes de hacer la solicitud, se construye un objeto postOrder, que contiene los detalles de la orden a colocar, como el símbolo, la cantidad, el lado, el tipo, el precio y las opciones (en caso de que sea necesario).

Finalmente, se proporciona un objeto default con todas las funciones exportadas, para que puedan ser importadas y utilizadas en otros módulos. */
